import React, { Component } from 'react';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { PricingSection } from './components/PricingSection';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0f] text-white overflow-x-hidden" data-id="element-0">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 px-4 py-4" data-id="element-1">
        <div className="max-w-6xl mx-auto" data-id="element-2">
          <div className="glass rounded-2xl px-6 py-3 flex items-center justify-between" data-id="element-3">
            {/* Logo */}
            <a href="/" className="flex items-center gap-2 group" data-id="element-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center" data-id="element-5">
                <span className="text-white font-bold text-sm" data-id="element-6">H</span>
              </div>
              <span className="font-semibold text-white group-hover:text-cyan-400 transition-colors" data-id="element-7">
                Holograph
              </span>
            </a>

            {/* Nav Links */}
            <div className="hidden md:flex items-center gap-8" data-id="element-8">
              <a href="#features" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-9">
                Features
              </a>
              <a href="#pricing" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-10">
                Pricing
              </a>
              <a href="#docs" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-11">
                Docs
              </a>
            </div>

            {/* CTA */}
            <button className="btn-glass text-sm py-2 px-4" data-id="element-12">Get Started</button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main data-id="element-13">
        <HeroSection data-id="element-14" />
        <ServicesSection data-id="element-15" />
        <PricingSection data-id="element-16" />
      </main>

      {/* Footer */}
      <footer className="relative py-16 px-4 border-t border-white/5" data-id="element-17">
        <div className="max-w-6xl mx-auto" data-id="element-18">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-19">
            {/* Brand */}
            <div className="md:col-span-1" data-id="element-20">
              <div className="flex items-center gap-2 mb-4" data-id="element-21">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center" data-id="element-22">
                  <span className="text-white font-bold text-sm" data-id="element-23">H</span>
                </div>
                <span className="font-semibold text-white" data-id="element-24">Holograph</span>
              </div>
              <p className="text-gray-500 text-sm" data-id="element-25">
                The future of interface design, today.
              </p>
            </div>

            {/* Links */}
            <div data-id="element-26">
              <h4 className="text-white font-medium mb-4" data-id="element-27">Product</h4>
              <ul className="space-y-2" data-id="element-28">
                {['Features', 'Pricing', 'Changelog', 'Roadmap'].map(item => <li key={item} data-id="element-29">
                    <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-30">
                      {item}
                    </a>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-31">
              <h4 className="text-white font-medium mb-4" data-id="element-32">Resources</h4>
              <ul className="space-y-2" data-id="element-33">
                {['Documentation', 'Components', 'Templates', 'Examples'].map(item => <li key={item} data-id="element-34">
                      <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-35">
                        {item}
                      </a>
                    </li>)}
              </ul>
            </div>

            <div data-id="element-36">
              <h4 className="text-white font-medium mb-4" data-id="element-37">Company</h4>
              <ul className="space-y-2" data-id="element-38">
                {['About', 'Blog', 'Careers', 'Contact'].map(item => <li key={item} data-id="element-39">
                    <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-40">
                      {item}
                    </a>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-41">
            <p className="text-gray-500 text-sm" data-id="element-42">
              © 2026 Holograph. All rights reserved.
            </p>
            <div className="flex items-center gap-6" data-id="element-43">
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-44">
                Privacy
              </a>
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-45">
                Terms
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}